module.exports = __webpack_public_path__ + "static/OpenSans-Regular-eb946e929329516d98672487006f3383.woff2";